import getLiveElement from './get-live-element';
import getParentLiveElement from './get-parent-live-element';
import getParentLiveElementId from './get-parent-live-element-id';
import getStaticElement from './get-static-element';
import getMappedHTML from './get-mapped-html';
import getElementAttribute from './get-element-attribute';
import getLiveElementByCoords from './get-live-element-by-coords';
import getLiveElementId from './get-live-element-id';
import getLiveDocument from './get-live-document';
import getSelection from './get-selection';
import getLiveElementLastChild from './get-live-element-last-child';
import getLiveElementByStaticElement from './get-live-element-by-static-element';
import getScrollPosition from './get-scroll-position';
import getElementBoundsInIframe from './get-element-bounds-in-iframe';
import getElementOffset from './get-element-offset';
import getPageBlocks from './get-page-blocks';
import getResponsiveAttribute from './get-responsive-attribute';

export default {
  getLiveElement,
  getParentLiveElement,
  getParentLiveElementId,
  getStaticElement,
  getMappedHTML,
  getElementAttribute,
  getLiveElementByCoords,
  getLiveElementByStaticElement,
  getLiveElementId,
  getLiveDocument,
  getSelection,
  getLiveElementLastChild,
  getScrollPosition,
  getElementBoundsInIframe,
  getElementOffset,
  getPageBlocks,
  getResponsiveAttribute,
};
